<section class="forgot">
  	<div class="container h-100">
      	<div class="row align-items-center h-100 justify-content-center">
        	<div class="card rounded-0 card-forgot border-0">
            <div class="text-center mb-3">
              <img src="assets/images/header-logo.png" />
            </div>

            <div class="card-body">

              <crm-alert #alert></crm-alert>
              
              <form [formGroup]="forgotForm" name="form" class="form" (ngSubmit)="onSubmit()">
               
                <div class="form-group row">
                  <label for="inputEmail" class="col-sm-3 col-form-label">Email</label>
                  <div class="col-sm-10">
                    <input type="email" formControlName="USER_EMAIL" name="USER_EMAIL" id="inputEmail" class="form-control rounded-0"
                           placeholder="Email" />
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-6 mx-auto">
                    <button [disabled]="!forgotForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0">
                      Reset Password
                    </button>
                  </div>
                </div>

              </form>

            </div>
       		</div>
      	</div>
  	</div>
</section>
